import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { TwoColumnLayout, TwoColumnLayoutChildren } from '@dojo/widgets/two-column-layout';

import css from '../css/index.m.css';

export interface LayoutProperties {
	xqa?: string;
	key?: string;
	id?: string;
	classes?: string[];
}

export interface LayoutChildren extends TwoColumnLayoutChildren {}

const factory = create({ theme }).properties<LayoutProperties>().children<LayoutChildren>();

export const Layout = factory(({ id: widgetId, properties, children, middleware: { theme } }) => {
	const { layout, columns, trailingColumn, content, tools } = theme.classes(css);
	const { xqa = 'mc-layout-widget', id, key = `content-containerid-${id || widgetId}`, classes = [] } = properties();
	let { leading, trailing } = children()[0];

	if (!Array.isArray(leading)) {
		leading = [leading];
	}

	if (!Array.isArray(trailing)) {
		trailing = [trailing];
	}

	const overrides = {
		'@dojo/widgets/two-column-layout': {
			column: [columns],
			small: [trailingColumn]
		}
	};

	return v('div', { xqa, key, id, widgetId, classes: [theme.variant(), layout, ...classes] }, [
		w(TwoColumnLayout, { key: `two-column-layout`, breakpoint: 1024, classes: overrides, bias: 'leading' }, [
			{
				leading: v('div', { xqa: `${id}-content`, classes: [content] }, leading),
				trailing: v('div', { xqa: `${id}-tools-sidebar`, classes: [tools] }, trailing)
			}
		])
	]);
});
